<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<section
    class="protection__upgrades__wrapper"
    [ngClass]="{ international: isInternational }"
>
    <div class="protection__title">
        <h2 class="title">
            {{
                'fe_details_step3_protection_level_protection_title_title'
                    | translate
            }}
        </h2>
        <h3 class="subtitle">
            {{
                'fe_details_step3_protection_level_protection_title_subtitle'
                    | translate
            }}
        </h3>
        <button
            *ngIf="!isInternational"
            type="button"
            class="protection__insurance-info"
            (click)="insuranceInfoModal.fire()"
        >
            <svg
                class="protection__insurance-info__icon"
                xmlns="http://www.w3.org/2000/svg"
                width="25.142"
                height="24.581"
                viewBox="0 0 25.142 24.581"
                aria-hidden="true"
            >
                <path
                    d="M24.44,0H.6A.646.646,0,0,0,0,.6V24.04c0,.6.7.7,1.1.3l5.609-5.709a.759.759,0,0,1,.4-.2H24.541a.646.646,0,0,0,.6-.6V.6A.859.859,0,0,0,24.44,0ZM12.521,14.424h0a1,1,0,1,1,0-2,1.077,1.077,0,0,1,1,1A.946.946,0,0,1,12.521,14.424Zm1.8-4.608c-.1.1-.2.1-.3.2a.724.724,0,0,0-.4.6,1.2,1.2,0,0,1-1.2,1.1,1.122,1.122,0,0,1-1.2-1v-.1a3.09,3.09,0,0,1,1.7-2.5,1.061,1.061,0,0,0,.6-1.1,1.087,1.087,0,0,0-.8-.8.779.779,0,0,0-.8.2.907.907,0,0,0-.3,1c0,.2,0,.4-.2.5a1.114,1.114,0,0,1-1.9-.7,3.2,3.2,0,0,1,1.1-2.4,3.228,3.228,0,0,1,2.5-.7A3.211,3.211,0,0,1,14.324,9.816Z"
                    fill="#ca93fe"
                ></path>
            </svg>
            <span class="protection__insurance-info__text">{{
                'fe_details_step3_protection_level_insurance_info_link'
                    | translate
            }}</span>
        </button>
        <span class="protection__free__days" *ngIf="hasFreeDays">
            <span class="material-symbols-outlined" aria-hidden="true"
                >event_available</span
            >
            {{ freeDaysKey | translate | replace: { days: freeDays } }}
        </span>
    </div>
    <div class="protection__body">
        <div
            class="protection__card__wrapper"
            *ngFor="let insurance of insurances; let i = index"
        >
            <div
                class="protection__card"
                [ngClass]="{
                    active: isActive[i],
                    recommended: i === recommendedIndex,
                    international: isInternational,
                    selectable: !disabled
                }"
                (click)="onCardClick(insurance, i)"
            >
                <div
                    class="protection__ribbon__wrap"
                    *ngIf="!isInternational && getDiscount(insurance) as discount"
                >
                    <div class="protection__ribbon">
                        <span class="protection__ribbon__percentage">{{
                            discount
                        }}</span>
                        <span class="protection__ribbon__text">{{
                            'fe_details_step3_protection_level_protection_card_ribbon_discount'
                                | translate
                        }}</span>
                    </div>
                </div>
                <span
                    class="protection__card__check"
                    *ngIf="isActive[i] && !isInternational"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="9"
                        height="9"
                    >
                        <path
                            d="M5 12.5 10 17.5 19 7"
                            fill="none"
                            stroke="#fff"
                            stroke-width="3.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </span>
                <div
                    class="protection__badge"
                    *ngIf="i === recommendedIndex && !isInternational"
                >
                    <p class="protection__badge__text">
                        <img alt="" [src]="'images/like.svg' | cdn" />
                        {{ 'fe_step2_card_vehicle_featured' | translate }}
                    </p>
                </div>
                <div class="protection__card__head">
                    <div class="protection__card__name">
                        <span class="protection__card__icon">
                            <img
                                class="protection__card__icon-default"
                                alt=""
                                [src]="getMeta(insurance).icon"
                            />
                            <img
                                class="protection__card__icon-active"
                                alt=""
                                [src]="getMeta(insurance).iconActive"
                            />
                        </span>
                        <h4 [innerHTML]="insurance.title"></h4>
                    </div>
                    <p
                        class="protection__card__tagline"
                        *ngIf="!isInternational"
                    >
                        {{ getMeta(insurance).tagline | translate }}
                    </p>
                    <p class="protection__card__price" *ngIf="!isInternational">
                        <img
                            class="protection__card__price__icon"
                            [src]="'images/tag.svg' | cdn"
                            alt=""
                        />
                        <span class="protection__card__price__amount"
                            >{{ getPrice(insurance) | formatNumber }}</span
                        >
                        {{ currency }}/{{
                            'fe_details_step3_protection_level_protection_card_middle_pay_day'
                                | translate
                                | lowercase
                        }}
                    </p>
                    <p class="protection__card__price" *ngIf="isInternational">
                        {{ getPrice(insurance) | formatNumber }}
                        {{ currency }}/{{
                            'fe_details_step3_protection_level_protection_card_middle_pay_day'
                                | translate
                        }}
                    </p>
                    <div
                        class="protection__card__summary"
                        [class.protection__card__summary--no-savings]="
                            !getSavings(insurance)
                        "
                        *ngIf="!isInternational && getTotal(insurance) as total"
                    >
                        <p class="protection__card__summary__total">
                            <span
                                class="protection__card__summary__total__label"
                                >{{
                                    totalDaysKey
                                        | translate
                                        | replace: { days: rentDays }
                                }}</span
                            >
                            <span
                                class="protection__card__summary__total__value"
                                >{{ total | formatNumber }}
                                <span
                                    class="protection__card__summary__total__currency"
                                    >{{ currency }}</span
                                ></span
                            >
                        </p>
                        <p
                            class="protection__card__summary__savings"
                            *ngIf="getSavings(insurance) as savings"
                        >
                            <img
                                [src]="'images/percentage.svg' | cdn"
                                alt="discount"
                            />
                            <span>
                                {{
                                    'fe_details_step3_protection_level_protection_card_middle_savings_discount'
                                        | translate
                                }}
                                {{ savings | formatNumber }}
                                {{ currency }}
                            </span>
                        </p>
                    </div>
                </div>
                <div class="protection__card__features">
                    <ul *ngIf="!isInternational">
                        <li
                            *ngFor="let feature of getFeatures(insurance)"
                            [class.protection__card__feature--strong]="
                                isHighlightedFeature(feature)
                            "
                        >
                            <svg
                                *ngIf="!isHighlightedFeature(feature)"
                                class="protection__card__feature-icon"
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                            >
                                <path
                                    d="M4 12.5 9.5 18 20 6"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2.1"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            <span>{{ feature.description }}</span>
                        </li>
                    </ul>
                    <div
                        class="protection__card__details-wrap"
                        *ngIf="isInternational"
                        [class.open]="isActiveDetails[i]"
                    >
                        <button
                            class="protection__card__details"
                            (click)="$event.stopPropagation(); toggleDetails(i)"
                            [disabled]="disabled"
                        >
                            <img
                                class="protection__card__details-icon"
                                [class.open]="isActiveDetails[i]"
                                [src]="'images/chevron-alt-down.png' | cdn"
                                alt=""
                            />
                            <span>{{
                                (isActiveDetails[i]
                                    ? 'fe_details_step3_protection_level_button_info_hide'
                                    : 'fe_details_step3_protection_level_button_info'
                                ) | translate
                            }}</span>
                        </button>
                        <div
                            class="protection__popover"
                            *ngIf="isActiveDetails[i]"
                            (click)="$event.stopPropagation()"
                        >
                            <button
                                class="protection__popover__close"
                                (click)="
                                    $event.stopPropagation(); closeDetails(i)
                                "
                            >
                                <span class="material-symbols-outlined"
                                    >close</span
                                >
                            </button>
                            <div
                                class="protection__popover__content"
                                [innerHTML]="insurance.description"
                            ></div>
                        </div>
                    </div>
                </div>
                <div class="protection__card__footer">
                    <button
                        class="protection__card__cta"
                        [class.selected]="isActive[i]"
                        (click)="
                            $event.stopPropagation(); onCardClick(insurance, i)
                        "
                        [disabled]="disabled"
                    >
                        {{ getCtaKey(insurance, i) | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>
<fe-insurance-info-modal #insuranceInfoModal></fe-insurance-info-modal>
